<template>
  <div id="page-wrapper">
    <v-app-bar
      id="topbar-post-login"
      color="transparent"
      dark
      dense
      fixed
      prominent
    >
      <div class="mt-7">
        <span>SECRETARIA DE EDUCAÇÃO E ESPORTES</span>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title class="d-flex">
        <div class="logo-container">
          <img
            class="app-icon"
            src="https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png"
            alt="brasão-home-64px"
          />
        </div>
      </v-toolbar-title>
    </v-app-bar>

    <div id="background-image-wrapper">
      <v-container class="fill-height d-flex align-center justify-center">
        <vue-aos animation-class="animate__zoomInLeft animate__animated">
          <v-row justify="center" align="center" style="height: 80vh">
            <v-col cols="12" md="8" lg="7">
              <v-card
                elevation="10"
                class="pt-5 px-10 pb-6 rounded-lg"
                color="rgba(255, 255, 255, 0.9)"
              >
                <v-form ref="form" v-model="valid" @submit.prevent="recuperarSenha">
                  <v-row>
                    <v-col class="text-center">
                      <img src="/img/siglasigfoco.svg" alt="brasão-home-64px" />
                      <h1 class="subtitle-1 blue--text text--darken-4 font-weight-bold">
                        Recuperar Senha
                      </h1>
                    </v-col>
                  </v-row>

                  <v-row>
                    <p>
                      Informe o <strong>CPF e o E-mail</strong> da conta que deseja
                      recuperar senha e clique no botão
                      <strong>Recuperar Senha</strong>. O sistema enviará um link de
                      acesso para que seja feita a alteração da senha.
                    </p>
                  </v-row>

                  <v-row class="mb-4">
                    <v-col>
                      <v-text-field
                        v-model="user.cpf"
                        solo
                        outlined
                        dense
                        :rules="[(v) => $required(v), (v) => $validarCPF(v)]"
                        placeholder="CPF*"
                        v-mask="'###.###.###-##'"
                        class="rounded-lg"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mb-4">
                    <v-col>
                      <v-text-field
                        v-model="user.email"
                        solo
                        outlined
                        dense
                        :rules="[(v) => $required(v), (v) => $email(v)]"
                        placeholder="E-mail*"
                        class="rounded-lg"
                        prepend-inner-icon="mdi-lock"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="d-flex justify-center">
                    <v-btn color="primary" type="submit" class="py-4 px-6 mr-3 rounded-lg">
                      Recuperar Senha
                    </v-btn>
                    <v-btn outlined @click="cancelar()" class="py-4 px-6 mr-3 rounded-lg">
                      Cancelar
                    </v-btn>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </vue-aos>
      </v-container>
    </div>
  </div>
</template>
  
<script>
import VueAos from "vue-aos";
import PageLoadingMixin from "~/mixins/page-loading.mixin";
import AcessoService from "~/services/acesso.service"

export default {
  name: "TrocarSenha",
  mixins: [PageLoadingMixin, AcessoService],
  components: { VueAos },
  data: () => ({
    user: {
      cpf: null,
      email: null,
    },
    valid: false,
    loading: false,
  }),
  methods: {
    recuperarSenha: function () {
      const save = () => {
        const payload = {
          cpf: this.$unMask(this.user.cpf),
          email: this.user.email,
        };
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          return this.$solicitarRecuperacaoSenha(payload);
        });
      };

      if (this.$validarFormulario()) {
        save().then(({data}) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    cancelar() {
      this.$router.push({ path: "/login" });
    }
  },
};
</script>
  
<style scoped>

.v-btn:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out;
}

.fill-height {
  height: 100vh;
}

.v-text-field__slot input {
  font-size: 1.1rem;
}

a {
  color: rgb(47, 31, 168);
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

</style>
  